import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia, Section, TextBox, VideoShort } from '../../components/imports';

const Content = () => {

  const BottleShotRef = useRef(null);
  const animaticRef = useRef(null);

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>

          <div className='relative resp flex flex-col lg:flex-row lg:h-[100svh] gap-x-6'>
            <ImageMedia
              bypass={false}
              key={"money"}
              src={require('./assets/100FCFA_Stills002.png')}
              className=""
            />
            <ImageMedia
            bypass={false}
              key={"money2"}
              src={require('./assets/100FCFA_Stills001.jpg')}
              className=""
            />
          </div>

          <Section center className={"space-y-16"}>
            <VideoShort loop videoRef={animaticRef} src={require('./assets/Animatics_Focus_100FCFA_0004_CFA_a.mp4')} className={"!relative object-contain resp object-bottom max-h-[60vh] full="} />

            <ImageMedia
              // bypass
              key={"HeroImage"}
              src={require('./_cover.JPG')}
              className="relative md:landscape:scale-[100%] full object-cover object-top"
            />
          </Section>


          <Section padded center className={"pb-0"}>
            <TextBox resp title={"Fine Product Photography"} className={"mb-10"} descr={"Later as the company put out its refined labels, we took the 1L to the 3D lab to make more renders giving the brand neat image representation and top tier creativity."} />

            <MotionContent imgRef={BottleShotRef} height={"height"} className="justify-center"
              refDiv={require('./assets/CSMNC_SCN01_R03.jpg')}>
              <ImageMedia bypass
                key={"BottleShot"}
                src={require('./assets/CSMNC_SCN01_R03.jpg')}
                className="full"
              />
            </MotionContent>
          </Section>
        </div>
      )}
    </ThisProject>
  )
}

export default Content